export default {
    "{count} Hour | {count} Hours": "{count} heure | {count} heures",
    "{count} Minute | {count} Minutes": "{count} minute | {count} minutes",
    "History": "Historique",
    "Date": "Date",
    "Description": "Description",
    "Amount": "Quantité",
    "Deleted": "Supprimé"
}